import type { ReactNode } from 'react'

export interface FieldProps {label: string; children: ReactNode; className?: string}

export function Field({label, children, className = ''}: FieldProps) {
  return <label className={`ui-field ${className}`.trim()}><span>{label}</span>{children}</label>
}
